import {
  required,
  Create,
  SimpleForm,
  ImageField,
  ImageInput,
  BooleanInput,
  TextInput,
  NumberInput,
  FormDataConsumer,
  minLength,
  maxLength,
  SelectInput,
  ReferenceInput,
} from "react-admin";

import { CustomToolbar } from "../../../utils";

const validateRequired = required();
const validateAgreement = [required(), minLength(0), maxLength(500)];
const selectStyle = { width: "256px", minWidth: "256px" };

const LabCreate = (props) => (
  <Create redirect="list" title="Novo Laboratório" {...props}>
    <SimpleForm redirect="list" toolbar={<CustomToolbar />}>
      <ReferenceInput
        sort={{ field: "name", order: "ASC" }}
        perPage={999}
        source="groupId"
        reference="groups"
      >
        <SelectInput
          style={selectStyle}
          label="Grupo"
          optionText="name"
          optionValue="id"
          validate={validateRequired}
        />
      </ReferenceInput>

      <TextInput 
      label="Nome" 
      source="name" 
      validate={validateRequired} 
      resettable
      />
      <TextInput
        placeholder="ex: https://rxpro.com.br"
        label="URL"
        source="url"
        validate={validateRequired}
        resettable
      />
      <TextInput
        label="Contrato Flash"
        source="externalId"
        validate={validateRequired}
        resettable
      />
      <FormDataConsumer>
        {({ formData }) => (
          <>
            <BooleanInput
              label="Pedir Optin (aceite para envio de amostra)"
              source="agreementRequired"
              resettable="true"
            />
            {formData.agreementRequired && (
              <div>
                <NumberInput
                  label="Duração da assinatura"
                  helperText="(meses)"
                  source="signDurationMonths"
                  style={{ marginTop: "5px", marginBottom: "10px" }}
                  resettable
                />
                <TextInput
                  label="Termo de Aceite"
                  source="agreement"
                  fullWidth
                  multiline
                  helperText={`${
                    formData.agreement ? formData.agreement.length : "0"
                  }/500 caracteres`}
                  validate={validateAgreement}
                />
              </div>
            )}
          </>
        )}
      </FormDataConsumer>
      <ImageInput source="logo" label="Logotipo" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Create>
);

export default LabCreate;
